import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Switch,
    Tooltip,
    Typography
} from '@mui/material';
import CallMade from '@mui/icons-material/CallMade';
import CancelIcon from '@mui/icons-material/Cancel';
import { green } from '@mui/material/colors';
import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import Configuracao from '../../util/Configuracao';
import NumeroProcesso from '../NumeroProcesso';
import ReactComponent from '../ReactComponent';
import ModalConfirmacao from './ModalConfirmacao';

class ModalEnviarProcessosEmLotePJe extends ReactComponent {
    todosSelecionados = false;
    todosAcordaosSelecionados = false;
    todosMovimentosSelecionados = false;
    todasCertidoesSelecionadas = false;
    loading = true;
    botoes = false;
    quantidadeProcessosPJe;
    abrirMensagem = false;
    progressoEnvio = '';
    // TODO Quando autorizado, remover comentário para enviar acórdãos do SIJ
    origemPje = this.salaSessaoStore.existeSessaoSIJ ? !this.isComponenteHabilitado('EnvioAcordaoSIJ') : true;
    openModalConfirmacaoAcordaosNaoVerificados = false;

    reactionDialogOpen = reaction(
        () => this.observableProps.open,
        () => this.limparProcessoPesquisa()
    );

    handleChangeOrigem = () => {
        this.reset();
        this.origemPje = !this.origemPje;
    };

    reactionProcessos = reaction(
        () => this.observableProps.processos,
        () => {
            this.inicializar();
        }
    );

    constructor(props) {
        super(props);

        makeObservable(this, {
            todosSelecionados: observable,
            todosAcordaosSelecionados: observable,
            todosMovimentosSelecionados: observable,
            todasCertidoesSelecionadas: observable,
            loading: observable,
            botoes: observable,
            quantidadeProcessosPJe: observable,
            abrirMensagem: observable,
            origemPje: observable,
            progressoEnvio: observable,
            openModalConfirmacaoAcordaosNaoVerificados: observable,
            handleChangeOrigem: action,
            processos: computed,
            limparProcessoPesquisa: action,
            inicializar: action,
            handleClose: action,
            selecionarProcesso: action,
            handleChangeCheckbox: action,
            handleClickSelecionarTodos: action,
            processosSelecionadosComAcordaoNaoValidado: computed,
            handleClickSelecionarTodosMovimentos: action,
            handleClickSelecionarTodosAcordaos: action,
            handleClickSelecionarTodasCertidoes: action,
            handleEnviar: action,
            fecharModalConfirmacaoAcordaosNaoVerificados: action,
            enviar: action,
            setarQuantidades: action,
            setarMensagem: action,
            cancelar: action
        });
    }

    get processos() {
        let retorno = this.observableProps.processos;
        retorno = retorno.filter((registro) =>
            this.origemPje
                ? registro.processo.origem === Configuracao.ORIGEM_PJE
                : registro.processo.origem === Configuracao.ORIGEM_SIJ
        );
        retorno = retorno.filter((registro) => this.filtrarProcessoPeloNumero(registro));
        return retorno;
    }

    get mensagemSemProcessos() {
        return 'Não existem processos para envio' + this.complementoMensagemFiltrando;
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    inicializar = () => {
        let qtdProcessosPJe = 0;
        let qtdProcessosSIJ = 0;

        this.processos.map((registro) => {
            if (registro.processo.origem === Configuracao.ORIGEM_PJE) {
                qtdProcessosPJe++;
            } else if (registro.processo.origem === Configuracao.ORIGEM_SIJ) {
                qtdProcessosSIJ++;
            }
            return null;
        });

        this.quantidadeProcessosPJe = qtdProcessosPJe;
        this.quantidadeProcessosSIJ = qtdProcessosSIJ;

        this.botoes = true;
        this.loading = false;
    };

    handleClose = () => {
        this.reset();
        this.observableProps.onClose(false);
    };

    async componentDidMount() {
        this.inicializar();
    }

    reset() {
        this.todosSelecionados = false;
        this.todosAcordaosSelecionados = false;
        this.todosMovimentosSelecionados = false;
        this.todasCertidoesSelecionadas = false;
        this.processos.forEach((registro) => (registro.lancarMovimentos = false));
        this.processos.forEach((registro) => (registro.lancarAcordao = false));
        this.processos.forEach((registro) => (registro.lancarCertidao = false));
        this.processos.forEach((registro) => (registro.checkedEnviarProcessoOrigem = false));
    }

    selecionarProcesso = (registro) => {
        let selecionarTodos = true;
        registro.checkedEnviarProcessoOrigem = !registro.checkedEnviarProcessoOrigem;
        this.processos.forEach((registro) => {
            if (registro.checkedEnviarProcessoOrigem === false) {
                selecionarTodos = false;
            }
            return selecionarTodos;
        });
        if (selecionarTodos) {
            this.todosSelecionados = true;
        } else {
            this.todosSelecionados = false;
        }
    };

    handleChangeCheckbox = (opcao, registro) => {
        if (opcao === 'movimentoCNJ') {
            if (registro.lancarMovimentos && this.todosMovimentosSelecionados) {
                this.todosMovimentosSelecionados = false;
            }
            registro.lancarMovimentos = !registro.lancarMovimentos;
        } else if (opcao === 'certidao') {
            if (registro.lancarCertidao && this.todasCertidoesSelecionadas) {
                this.todasCertidoesSelecionadas = false;
            }
            registro.lancarCertidao = !registro.lancarCertidao;
        } else {
            if (registro.lancarAcordao && this.todosAcordaosSelecionados) {
                this.todosAcordaosSelecionados = false;
            }
            registro.lancarAcordao = !registro.lancarAcordao;
        }
    };

    handleClickSelecionarTodos = () => {
        this.todosSelecionados = !this.todosSelecionados;
        if (this.origemPje) {
            this.handleClickSelecionarTodasCertidoes();
            this.handleClickSelecionarTodosMovimentos();
        }
        this.handleClickSelecionarTodosAcordaos();
    };

    verificaSelecaoTodos = () => {
        if (this.todosMovimentosSelecionados && this.todosAcordaosSelecionados && this.todasCertidoesSelecionadas) {
            this.todosSelecionados = true;
        }
        if (
            (!this.todosMovimentosSelecionados ||
                !this.todosAcordaosSelecionados ||
                !this.todasCertidoesSelecionadas) &&
            this.todosSelecionados
        ) {
            this.todosSelecionados = false;
        }
    };

    get processosSelecionadosComAcordaoNaoValidado() {
        return this.processos.filter((registro) => registro.lancarAcordao && registro.acordaoValidado === false);
    }

    existeCheckboxSelecionado = () => {
        return this.processos.find(
            (registro) => registro.lancarMovimentos || registro.lancarCertidao || registro.lancarAcordao
        );
    };

    handleClickSelecionarTodosMovimentos = () => {
        this.todosMovimentosSelecionados = !this.todosMovimentosSelecionados;
        this.processos.forEach((registro) => {
            if (!this.isMovimentoDesabilitado(registro)) {
                registro.lancarMovimentos = this.todosMovimentosSelecionados;
            }
        });
        this.verificaSelecaoTodos();
    };

    handleClickSelecionarTodosAcordaos = () => {
        this.todosAcordaosSelecionados = !this.todosAcordaosSelecionados;
        this.processos.forEach((registro) => {
            if (!this.isAcordaoDesabilitado(registro)) {
                if (this.origemPje) {
                    if (registro.processo.origem === Configuracao.ORIGEM_PJE) {
                        registro.lancarAcordao = this.todosAcordaosSelecionados;
                    }
                } else {
                    if (registro.processo.origem === Configuracao.ORIGEM_SIJ) {
                        registro.lancarAcordao = this.todosAcordaosSelecionados;
                    }
                }
            }
        });
        this.verificaSelecaoTodos();
    };

    handleClickSelecionarTodasCertidoes = () => {
        this.todasCertidoesSelecionadas = !this.todasCertidoesSelecionadas;
        this.processos.forEach((registro) => {
            if (!this.isCertidaoDesabilitada(registro)) {
                registro.lancarCertidao = this.todasCertidoesSelecionadas;
            }
        });
        this.verificaSelecaoTodos();
    };

    isAcordaoDesabilitado(registro) {
        return (
            registro.acordaoTransferido ||
            !registro.acordaoAssinado ||
            !registro.acordaoObrigatorio ||
            (registro.processo.origem === Configuracao.ORIGEM_PJE &&
                !registro.movimentosTransferidos &&
                !registro.lancarMovimentos)
        );
    }

    isCertidaoDesabilitada(registro) {
        return (
            registro.certidaoJulgamentoTransferida ||
            !registro.certidaoJulgamentoAssinada ||
            (!registro.movimentosTransferidos && !registro.lancarMovimentos)
        );
    }

    isMovimentoDesabilitado(registro) {
        return registro.movimentosTransferidos || !registro.movimentosCadastrados;
    }

    handleEnviar = () => {
        if (this.processosSelecionadosComAcordaoNaoValidado.length > 0) {
            this.openModalConfirmacaoAcordaosNaoVerificados = true;
        } else {
            this.enviar();
        }
    };

    fecharModalConfirmacaoAcordaosNaoVerificados = () => {
        this.openModalConfirmacaoAcordaosNaoVerificados = false;
    };

    TAMANHO_BATCH = 20;

    dividirEmBatches(array, tamanho) {
        const batches = [];
        for (let i = 0; i < array.length; i += tamanho) {
            batches.push(array.slice(i, i + tamanho));
        }
        return batches;
    }

    async enviarBatchesSequencialmente(sessaoId, processos, funcaoTransferir, tipoLabel, totalGeral, enviadosAte) {
        const batches = this.dividirEmBatches(processos, this.TAMANHO_BATCH);
        const resultados = [];
        let enviados = enviadosAte;

        for (const batch of batches) {
            enviados += batch.length;
            this.progressoEnvio = `Enviando ${tipoLabel}... (${enviados}/${totalGeral})`;
            const resultado = await funcaoTransferir(sessaoId, batch);
            resultados.push(resultado);
        }

        return { resultados, enviados };
    }

    enviar = async () => {
        this.openModalConfirmacaoAcordaosNaoVerificados = false;
        try {
            this.botoes = false;
            this.progressoEnvio = '';

            let processos = this.processos.reduce(
                (acumulador, registro) => {
                    acumulador.processosParaEnviarAcordao[registro.sessaoId] =
                        acumulador.processosParaEnviarAcordao[registro.sessaoId] || [];
                    acumulador.processosParaEnviarCertidao[registro.sessaoId] =
                        acumulador.processosParaEnviarCertidao[registro.sessaoId] || [];
                    acumulador.processosParaEnviarMovimentos[registro.sessaoId] =
                        acumulador.processosParaEnviarMovimentos[registro.sessaoId] || [];

                    registro.lancarAcordao &&
                        acumulador.processosParaEnviarAcordao[registro.sessaoId].push(registro.processo.numeroCompleto);
                    registro.lancarCertidao &&
                        acumulador.processosParaEnviarCertidao[registro.sessaoId].push(
                            registro.processo.numeroCompleto
                        );
                    registro.lancarMovimentos &&
                        acumulador.processosParaEnviarMovimentos[registro.sessaoId].push(
                            registro.processo.numeroCompleto
                        );
                    return acumulador;
                },
                {
                    processosParaEnviarMovimentos: {},
                    processosParaEnviarAcordao: {},
                    processosParaEnviarCertidao: {}
                }
            );

            const labels = { movimento: ' - Movimento', certidao: ' - Certidão', acordao: ' - Acórdão' };
            let mensagemErro = [];
            let erroMovimento = 0;
            let erroCertidao = 0;
            let erroAcordao = 0;

            const coletarErros = (resultados, tipo) => {
                resultados.forEach((resultado) => {
                    if (resultado?.data) {
                        resultado.data.forEach((processo) => {
                            if (processo.tipo === 'ERRO') {
                                mensagemErro.push(processo.elemento + labels[tipo]);
                                if (tipo === 'movimento') erroMovimento++;
                                else if (tipo === 'certidao') erroCertidao++;
                                else if (tipo === 'acordao') erroAcordao++;
                            }
                        });
                    }
                });
            };

            // Movimentos
            const sessoesMovimentos = Object.keys(processos.processosParaEnviarMovimentos);
            const totalMovimentos = sessoesMovimentos.reduce(
                (total, sessao) => total + new Set(processos.processosParaEnviarMovimentos[sessao]).size,
                0
            );
            if (totalMovimentos > 0) {
                let enviados = 0;
                for (const sessao of sessoesMovimentos) {
                    const processosUnicos = [...new Set(processos.processosParaEnviarMovimentos[sessao])];
                    if (processosUnicos.length > 0) {
                        const resultado = await this.enviarBatchesSequencialmente(
                            sessao,
                            processosUnicos,
                            (s, p) => this.movimentoCNJService.transferirMovimentos(s, p),
                            'movimentos',
                            totalMovimentos,
                            enviados
                        );
                        enviados = resultado.enviados;
                        coletarErros(resultado.resultados, 'movimento');
                    }
                }
                if (mensagemErro.length === 0) {
                    await this.recarregar();
                    this.mensagemStore.abrirMensagemSucesso('Movimento(s) enviado(s) com sucesso.');
                }
            }

            // Certidões
            const sessoesCertidao = Object.keys(processos.processosParaEnviarCertidao);
            const totalCertidoes = sessoesCertidao.reduce(
                (total, sessao) => total + new Set(processos.processosParaEnviarCertidao[sessao]).size,
                0
            );
            if (totalCertidoes > 0) {
                const errosAntes = mensagemErro.length;
                let enviados = 0;
                for (const sessao of sessoesCertidao) {
                    const processosUnicos = [...new Set(processos.processosParaEnviarCertidao[sessao])];
                    if (processosUnicos.length > 0) {
                        const resultado = await this.enviarBatchesSequencialmente(
                            sessao,
                            processosUnicos,
                            (s, p) => this.certidaoService.transferirCertidao(s, p),
                            'certidões',
                            totalCertidoes,
                            enviados
                        );
                        enviados = resultado.enviados;
                        coletarErros(resultado.resultados, 'certidao');
                    }
                }
                if (mensagemErro.length === errosAntes) {
                    await this.recarregar();
                    this.mensagemStore.abrirMensagemSucesso('Certidão(ões) enviada(s) com sucesso.');
                }
            }

            // Acórdãos
            const sessoesAcordao = Object.keys(processos.processosParaEnviarAcordao);
            const totalAcordaos = sessoesAcordao.reduce(
                (total, sessao) => total + new Set(processos.processosParaEnviarAcordao[sessao]).size,
                0
            );
            if (totalAcordaos > 0) {
                const errosAntes = mensagemErro.length;
                let enviados = 0;
                for (const sessao of sessoesAcordao) {
                    const processosUnicos = [...new Set(processos.processosParaEnviarAcordao[sessao])];
                    if (processosUnicos.length > 0) {
                        const resultado = await this.enviarBatchesSequencialmente(
                            sessao,
                            processosUnicos,
                            (s, p) => this.acordaoService.transferirAcordao(s, p),
                            'acórdãos',
                            totalAcordaos,
                            enviados
                        );
                        enviados = resultado.enviados;
                        coletarErros(resultado.resultados, 'acordao');
                    }
                }
                if (mensagemErro.length === errosAntes) {
                    await this.recarregar();
                    this.mensagemStore.abrirMensagemSucesso('Acordão(s) enviado(s) com sucesso.');
                }
            }

            if (mensagemErro.length > 0) {
                this.setarMensagem(mensagemErro);
                this.setarQuantidades(erroMovimento, erroCertidao, erroAcordao);
            }

            this.cancelar();
        } catch (error) {
            console.error(error);
            this.cancelar();
            this.mensagemStore.abrirMensagemErro(
                'Ocorreu um erro na sua solicitação. Favor repetir o processo. Caso persista, contate o administrador.'
            );
        }
    };

    setarQuantidades(movimento, certidao, acordao) {
        this.salaSessaoStore.quantidadeErroMovimento = movimento;
        this.salaSessaoStore.quantidadeErroCertidao = certidao;
        this.salaSessaoStore.quantidadeErroAcordao = acordao;
    }

    setarMensagem(mensagem) {
        this.salaSessaoStore.mensagemErroEnvioLote = mensagem;
        this.salaSessaoStore.abrirMensagemErroLote = true;
    }

    async recarregar() {
        await this.salaSessaoStore.recarregarListaProcessos();
    }

    cancelar = () => {
        this.loading = false;
        this.progressoEnvio = '';
        this.todosSelecionados = false;
        this.todosMovimentosSelecionados = false;
        this.todasCertidoesSelecionadas = false;
        this.todosAcordaosSelecionados = false;
        this.reset();
        this.observableProps.onClose();
    };

    render() {
        if (!this.observableProps.open) {
            return null;
        }

        const pje = (
            <div>
                Enviar processos para o <span style={{ color: 'red', fontWeight: 'bold' }}>PJe</span>
            </div>
        );
        const esij = (
            <div>
                Enviar processos para o <span style={{ color: 'blue', fontWeight: 'bold' }}>SIJ</span>
            </div>
        );

        return (
            <>
                <Dialog
                    open={this.observableProps.open}
                    onClose={this.handleClose}
                    maxWidth="false"
                    fullWidth
                    PaperProps={{ style: { height: '100%', width: '950px', maxWidth: '95ww' } }}
                >
                    <DialogTitle id="simple-dialog-title">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            {this.origemPje ? pje : esij}
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'right' }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0px 10px' }}>
                                    <NumeroProcesso
                                        dense
                                        tooltip="Número do processo a ser pesquisado na listagem"
                                        callbackOnChange={this.callbackNumeroProcesso}
                                        clickLimpar={this.limparProcessoPesquisa}
                                    />
                                </div>
                                {this.salaSessaoStore.isSessaoMista() &&
                                    this.isComponenteHabilitado('EnvioAcordaoSIJ') && (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Typography>Alternar a lista de processos entre SIJ e PJe</Typography>
                                            <Switch
                                                checked={this.origemPje}
                                                onClick={this.handleChangeOrigem}
                                                color="primary"
                                                name="Origem"
                                            />
                                        </div>
                                    )}
                            </div>
                        </div>
                    </DialogTitle>
                    <DialogContent style={{ padding: '20px' }}>
                        {!this.loading && (
                            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ minWidth: '434px' }}>
                                        <Checkbox
                                            color="primary"
                                            onClick={this.handleClickSelecionarTodos}
                                            checked={this.todosSelecionados}
                                            value={'true'}
                                        />
                                        <span style={{ color: 'black' }}>Selecionar todos</span>
                                    </div>
                                    {this.origemPje && (
                                        <div style={{ minWidth: '190px' }}>
                                            <Tooltip
                                                placement={'top'}
                                                title={'Selecionar todos os movimentos'}
                                            >
                                                <div>
                                                    <Checkbox
                                                        color="primary"
                                                        onClick={this.handleClickSelecionarTodosMovimentos}
                                                        checked={this.todosMovimentosSelecionados}
                                                        value={'true'}
                                                    />
                                                    <span style={{ color: 'black' }}>Movimentos CNJ</span>
                                                </div>
                                            </Tooltip>
                                        </div>
                                    )}
                                    {this.parametroStore.usaCertidao() && this.origemPje && (
                                        <div style={{ minWidth: '140px' }}>
                                            <Tooltip
                                                placement={'top'}
                                                title={'Selecionar todas as certidões'}
                                            >
                                                <div>
                                                    <Checkbox
                                                        color="primary"
                                                        onClick={this.handleClickSelecionarTodasCertidoes}
                                                        checked={this.todasCertidoesSelecionadas}
                                                        value={'true'}
                                                    />
                                                    <span style={{ color: 'black' }}>Certidões</span>
                                                </div>
                                            </Tooltip>
                                        </div>
                                    )}
                                    <div>
                                        <Tooltip
                                            placement={'top'}
                                            title={'Selecionar todos os acórdãos'}
                                        >
                                            <div>
                                                <Checkbox
                                                    color="primary"
                                                    onClick={this.handleClickSelecionarTodosAcordaos}
                                                    checked={this.todosAcordaosSelecionados}
                                                    value={'true'}
                                                />
                                                <span style={{ color: 'black' }}>Acórdãos</span>
                                            </div>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', height: '100%', overflowY: 'auto' }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '100%',
                                            minHeight: '90px',
                                            maxHeight: '40px',
                                            padding: '0px 14px'
                                        }}
                                    >
                                        {this.processos.length > 0 ? (
                                            this.processos.map((registro) => {
                                                let processo = registro.processo;
                                                return (
                                                    <Fragment key={this.nextKey}>
                                                        <Divider />
                                                        <div
                                                            key={this.nextKey}
                                                            style={{ display: 'flex' }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    minWidth: '420px'
                                                                }}
                                                            >
                                                                {processo.numeroCompleto}
                                                            </div>
                                                            {this.origemPje && (
                                                                <div>
                                                                    <Tooltip
                                                                        placement={'top'}
                                                                        title={this.renderTooltipMovimento(registro)}
                                                                    >
                                                                        <div style={{ minWidth: '191px' }}>
                                                                            <Checkbox
                                                                                color="primary"
                                                                                onChange={this.handleChangeCheckbox.bind(
                                                                                    this,
                                                                                    'movimentoCNJ',
                                                                                    registro
                                                                                )}
                                                                                checked={
                                                                                    registro.lancarMovimentos ||
                                                                                    registro.movimentosTransferidos
                                                                                }
                                                                                disabled={this.isMovimentoDesabilitado(
                                                                                    registro
                                                                                )}
                                                                            />
                                                                            {this.renderDescricaoMovimento(registro)}
                                                                        </div>
                                                                    </Tooltip>
                                                                </div>
                                                            )}
                                                            {this.parametroStore.usaCertidao() && this.origemPje && (
                                                                <div>
                                                                    <Tooltip
                                                                        placement={'top'}
                                                                        title={this.renderTooltipCertidao(registro)}
                                                                    >
                                                                        <div style={{ minWidth: '140px' }}>
                                                                            <Checkbox
                                                                                color="primary"
                                                                                onChange={this.handleChangeCheckbox.bind(
                                                                                    this,
                                                                                    'certidao',
                                                                                    registro
                                                                                )}
                                                                                checked={
                                                                                    registro.lancarCertidao ||
                                                                                    registro.certidaoJulgamentoTransferida
                                                                                }
                                                                                disabled={this.isCertidaoDesabilitada(
                                                                                    registro
                                                                                )}
                                                                            />
                                                                            {this.renderDescricaoCertidao(registro)}
                                                                        </div>
                                                                    </Tooltip>
                                                                </div>
                                                            )}
                                                            <div style={{ paddingRight: '8px' }}>
                                                                <Tooltip
                                                                    placement={'top'}
                                                                    title={this.renderTooltipAcordao(registro)}
                                                                >
                                                                    <div>
                                                                        <Checkbox
                                                                            color="primary"
                                                                            onChange={this.handleChangeCheckbox.bind(
                                                                                this,
                                                                                'acordao',
                                                                                registro
                                                                            )}
                                                                            checked={
                                                                                registro.lancarAcordao ||
                                                                                registro.acordaoTransferido
                                                                            }
                                                                            disabled={this.isAcordaoDesabilitado(
                                                                                registro
                                                                            )}
                                                                        />
                                                                        {this.renderDescricaoAcordao(registro)}
                                                                    </div>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                );
                                            })
                                        ) : (
                                            <div style={{ marginTop: '8px' }}>{this.mensagemSemProcessos}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                        {this.loading || !this.botoes ? (
                            <div>
                                <CircularProgress size={25} /> {this.progressoEnvio || 'Aguarde...'}
                            </div>
                        ) : (
                            <div style={{ paddingLeft: '20px' }}>
                                {this.processos.length > 0 ? (
                                    <h4 style={{ color: '#b71c1c' }}>* Exibindo {this.processos.length} processo(s)</h4>
                                ) : (
                                    <h4 style={{ color: '#b71c1c' }}>* Não existem processos</h4>
                                )}
                            </div>
                        )}
                        <div>
                            <Button
                                onClick={this.handleClose}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                                sx={{ mr: 2 }}
                                disabled={!this.botoes}
                            >
                                Cancelar
                            </Button>
                            <Tooltip
                                title={
                                    !this.existeCheckboxSelecionado()
                                        ? 'Selecione um ou mais itens para enviar'
                                        : 'Enviar selecionado(s)'
                                }
                                placement="top"
                            >
                                <span>
                                    <Button
                                        onClick={this.handleEnviar}
                                        color="primary"
                                        variant="outlined"
                                        endIcon={<CallMade />}
                                        disabled={!this.existeCheckboxSelecionado() || !this.botoes}
                                    >
                                        Enviar
                                    </Button>
                                </span>
                            </Tooltip>
                        </div>
                    </DialogActions>
                </Dialog>

                <ModalConfirmacao
                    titulo={'Envio de informações para o PJe'}
                    open={this.openModalConfirmacaoAcordaosNaoVerificados}
                    callbackCancelar={this.fecharModalConfirmacaoAcordaosNaoVerificados}
                    callbackConfirmar={() => this.enviar()}
                >
                    <Typography display={'inline'}>
                        Atenção! Existem acórdãos não verificados pela secretaria. Deseja prosseguir?
                    </Typography>
                </ModalConfirmacao>
            </>
        );
    }

    renderDescricaoAcordao(registro) {
        if (registro.acordaoTransferido) {
            return <span style={{ color: green[700] }}>Acórdão</span>;
        }

        if (this.isAcordaoDesabilitado(registro)) {
            return <s style={{ color: 'grey' }}>Acórdão</s>;
        }

        return <Typography>Acórdão</Typography>;
    }

    renderDescricaoCertidao(registro) {
        if (!registro.certidaoJulgamentoAssinada || (!registro.movimentosTransferidos && !registro.lancarMovimentos)) {
            return <s style={{ color: 'grey' }}>Certidão</s>;
        }

        if (registro.certidaoJulgamentoTransferida) {
            return <span style={{ color: green[700] }}>Certidão</span>;
        }

        return <Typography>Certidão</Typography>;
    }

    renderDescricaoMovimento(registro) {
        if (!registro.movimentosCadastrados) {
            return <s style={{ color: 'grey' }}>Movimento CNJ</s>;
        }

        if (registro.movimentosTransferidos) {
            return <span style={{ color: green[700] }}>Movimento CNJ</span>;
        }

        return <Typography component="span">Movimento CNJ</Typography>;
    }

    renderTooltipAcordao(registro) {
        let stringPje = 'PJe';
        let stringSIJ = 'eSIJ';
        if (registro.acordaoTransferido) {
            return 'Acórdão transferido';
        } else if (!registro.acordaoObrigatorio) {
            return 'Não haverá publicação de acórdão';
        } else if (!registro.acordaoAssinado && registro.dataAssinaturaSistemaOrigem) {
            return (
                'Acórdão assinado no ' + (registro.processo.origem === Configuracao.ORIGEM_PJE ? stringPje : stringSIJ)
            );
        } else if (!registro.acordaoAssinado) {
            return 'Acórdão não assinado';
        } else if (
            !registro.movimentosTransferidos &&
            !registro.lancarMovimentos &&
            registro.processo.origem === Configuracao.ORIGEM_PJE
        ) {
            return 'É obrigatório enviar o movimento antes ou junto ao acórdão';
        } else {
            return (
                'Enviar acórdão para o ' +
                (registro.processo.origem === Configuracao.ORIGEM_PJE ? stringPje : stringSIJ)
            );
        }
    }

    renderTooltipCertidao(registro) {
        if (!registro.certidaoJulgamentoAssinada) {
            return 'Certidão não assinada';
        }

        if (!registro.movimentosTransferidos && !registro.lancarMovimentos) {
            return 'É obrigatório enviar os movimentos antes ou junto à certidão';
        }

        if (registro.certidaoJulgamentoTransferida) {
            return 'Certidão transferida';
        }

        return 'Enviar certidão para o PJe';
    }

    renderTooltipMovimento(registro) {
        if (!registro.movimentosCadastrados) {
            return 'Movimentos não cadastrados';
        }

        if (registro.movimentosTransferidos) {
            return 'Movimentos transferidos';
        }

        return 'Enviar movimento(s) para o PJe';
    }
}

export default inject('stores')(observer(ModalEnviarProcessosEmLotePJe));
